import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';

@Component({
  selector: 'app-text-value',
  templateUrl: './text-value.component.html',
  styleUrls: ['./text-value.component.scss'],
})
export class TextValueComponent implements OnInit, AfterViewInit {

  @ViewChild('valueElement') valueElement: ElementRef;

  @Input() label: string;
  @Input() value: string;
  @Input() valueHeight: number;

  constructor() {
  }

  ngAfterViewInit(): void {
    if (this.valueHeight) {

      const scrollcontainer = this.valueElement.nativeElement;

      scrollcontainer.ontouchmove = function (e) {
        e.stopPropagation();
      };
    }
  }

  ngOnInit() {

  }


}

export interface TextValueVO {
  label: string;
  value: string;
  _metadata?: any;
}
